import React from 'react';

import PinDrop from "@material-ui/icons/PinDrop";
import Phone from "@material-ui/icons/Phone";
import BusinessCenter from "@material-ui/icons/BusinessCenter";

import InfoArea from "../../components/InfoArea/InfoArea.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";

import './contactUs.css';

const SectionContactInfo = classes => (
  <GridContainer>
      <GridItem xs={12} sm={12} md={12} lg={12} className={classes.mlAuto}>
          <InfoArea
              className="info-area"
              title="CONÓCENOS"
              description={
                  <p>
                      <strong>Tunja, Boyacá, Colombia</strong>
                      <br/>
                      Cra 7 #1B-36, barrio La Florida
                  </p>
              }
              icon={PinDrop}
              iconColor="success"
          />
      </GridItem>
      <GridItem xs={12} sm={12} md={12} lg={12} className={classes.mlAuto}>
          <InfoArea
              className="info-area"
              title="LLÁMANOS"
              description={
                  <p>
                      <strong>(+57) 315 795 1330 - 313 208 9988</strong>
                      <br/>
                      Ofrecemos soporte de 8:00 am a 6:00 pm (GMT-5 Hora Colombiana).
                  </p>
              }
              icon={Phone}
              iconColor="success"
          />
      </GridItem>
      <GridItem xs={12} sm={12} md={12} lg={12} className={classes.mlAuto}>
          <InfoArea
              className="info-area"
              title="ESCRÍBENOS"
              description={
                  <p>
                      <strong>vivamoselcampo@gmail.com</strong>
                      <br/>
                      Te responderemos oportunamente.
                  </p>
              }
              icon={BusinessCenter}
              iconColor="success"
          />
      </GridItem>
    </GridContainer>
)

export default SectionContactInfo;



// WEBPACK FOOTER //
// ./src/views/ContactUsPage/SectionContactInfo.jsx